import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import { getEnvironment } from 'utils/environment'

const EnvironmentAlert = () => {
  return (
    <Box padding={2}>
      <Typography fontSize={14} color="gray" textAlign="center">
        env: {getEnvironment()}
      </Typography>
    </Box>
  )
}

export default EnvironmentAlert
